import Const from 'constants';
import {showPopup} from 'helpers/modal';

function getRoomId(sport, slateId) {
    return `${Const.SOCKET_SLATE_LIVE_UPDATES}/${sport}/${slateId}`;
}

let Socket = {
    subscribeToSlateLiveUpdates(slateId) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            return dispatch({
                type: Const.SOCKET_SUBSCRIBE,
                roomId: getRoomId(sportConfig.getSport(), slateId),
                options: {leaveAllRoomsBeforeSubscribing: true},
            });
        };
    },
    unsubscribeFromSlateLiveUpdates(slateId) {
        return (dispatch, getState) => {
            if (!slateId) {
                return;
            }

            const {sportConfig} = getState();

            dispatch({
                type: Const.SOCKET_UNSUBSCRIBE,
                roomId: getRoomId(sportConfig.getSport(), slateId),
            });
        };
    },
    socketSetSlate(data) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (!sportConfig.isModeMain()) {
                return;
            }

            console.log('Slate data handler: ', data);
            dispatch(this.applySlate(data.payload));
        };
    },
    socketSetGames(data) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (sportConfig.isModeBacktest()) {
                return;
            }

            console.log('Games data handler: ', data);
            dispatch(this.applyUpdatedGames(data.payload));
        };
    },
    socketSetPlayers(data) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (sportConfig.isModeBacktest()) {
                return;
            }

            const modificationType = sportConfig.isModeMain()
                ? Const.PLAYERS_MODIFICATION_TYPE_SET
                : Const.PLAYERS_MODIFICATION_TYPE_MERGE;

            try {
                console.log('Players data handler: ', data);
                dispatch(this.applyUpdatedPlayers(data.payload, {modificationType}));
            } catch (e) {
                e = e.stack || JSON.stringify(e);
                dispatch(showPopup(e));
            }
        };
    },
    socketUpdatePlayers(data) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (sportConfig.isModeBacktest()) {
                return;
            }

            try {
                console.log('Players data handler: ', data);
                dispatch(
                    this.applyUpdatedPlayers(data.payload, {
                        modificationType: Const.PLAYERS_MODIFICATION_TYPE_MERGE,
                    }),
                );
            } catch (e) {
                e = e.stack || JSON.stringify(e);
                dispatch(showPopup(e));
            }
        };
    },
    socketDeletePlayers(data) {
        return (dispatch, getState) => {
            const {sportConfig} = getState();

            if (!sportConfig.isModeMain()) {
                return;
            }

            try {
                console.log('Players data handler: ', data);
                dispatch(this.applyDeletedPlayers(data.payload));
            } catch (e) {
                e = e.stack || JSON.stringify(e);
                dispatch(showPopup(e));
            }
        };
    },
};

export default Socket;
